module.exports = __webpack_public_path__ + "static/media/levels_3_2.9af560ad.svg";